import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of ADA accommodation referrals routed to this provider by the
 *  ADA Coordinator and awaiting a clinical order — for the ADA nav ticker. */
export function useAdaReferrals(enabled = true, intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!enabled) return;
        let active = true;
        const fetchCount = () => api.get("/provider/ada/referrals/count")
            .then((r) => { if (active) setCount(r.data.count || 0); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        const onChanged = () => fetchCount();
        window.addEventListener("ada-referrals-changed", onChanged);
        return () => { active = false; clearInterval(id); window.removeEventListener("ada-referrals-changed", onChanged); };
    }, [enabled, intervalMs]);
    return count;
}
